import debounce from 'debounce'

const SIZE = 3.0
const ARROW_SIZE = 15

const rand = (min, max, multiplier = 100) => {
  min *= multiplier
  max *= multiplier
  return (Math.floor(Math.random() * (max - min + 1)) + min) / multiplier
}

const point = (size = SIZE) => `${rand(0, size)}px`

const pos = (index, numPoints) => `${(index / numPoints) * 100}%`

const calcNumPoints = (element) => {
  const numPoints = Math.round(element.offsetWidth / 20)
  return numPoints % 2 === 1 ? numPoints + 1 : numPoints
}

const getEdge = (numPoints) => new Array(numPoints).fill().map((i, index) => [ pos(index, numPoints), point() ])

const getClipPath = (edge) => {
  const points = [
    [ '0%', '0%' ], // top left
    ...edge, // top edge
    [ '100%', '0%' ], // top right
    [ '100%', '100%' ], // bottom right
    [ '0%', '100%' ] // top right
  ]
  return `polygon(${points.map(i => i.join(' ')).join(',')})`
}

export const applyPaper = (element) => {
  const numPoints = calcNumPoints(element)
  const hasArrow = String(element.getAttribute('class')).includes('has-arrow')
  const points = getEdge(numPoints, hasArrow)
  if (hasArrow) {
    const centerIndex = Math.ceil(points.length / 2)
    points[centerIndex - 1][1] = point(1.5)
    points[centerIndex][1] = `${ARROW_SIZE}px`
    points[centerIndex + 1][1] = point(1.5)
    element.style.marginTop = `-${ARROW_SIZE}px`
    const child = element.children[0]
    child.originalPadding = child.originalPadding || parseInt(window.getComputedStyle(child, null).getPropertyValue('padding-top'))
    child.style.paddingTop = `${child.originalPadding + ARROW_SIZE}px`
  } else {
    element.style.marginTop = '-3px'
  }
  element.style['clip-path'] = getClipPath(points)
}

export const applyPaperEffects = () => {
  const sections = document.querySelectorAll('#main .shopify-section:not(.no-paper)')
  sections.forEach((i, index) => {
    if (index > 0) {
      applyPaper(i)
    }
  })
  const elements = document.querySelectorAll('#shopify-section-layout-newsletter, #shopify-section-layout-footer, .has-paper-effect')
  elements.forEach(i => applyPaper(i))
}

export const initPaperEffect = () => {
  // Apply effect when DOM has loaded
  document.addEventListener('DOMContentLoaded', applyPaperEffects)
  // Auto apply paper to new elements with has-paper-effect class
  window.addEventListener('animationstart', (event) => {
    if (event.target.classList.contains('has-paper-effect')) {
      applyPaper(event.target)
    }
  })
  // Only fire resize handler if width changes (Safari fires this event on scroll)
  window._width = window.innerWidth
  window.addEventListener('resize', debounce(() => {
    if (window.innerWidth !== window._width) {
      window._width = window.innerWidth
      applyPaperEffects()
    }
  }, 200))
}
